import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  try {
    const v = localStorage.getItem("mf_ab");
    if (v) cfg.headers["X-AB-Variant"] = v;
    const s = localStorage.getItem("mf_src");
    if (s) cfg.headers["X-Source"] = s;
    const r = localStorage.getItem("mf_ref");
    if (r) cfg.headers["X-Referral"] = r;
  } catch { /* storage unavailable */ }
  return cfg;
});

// Capture ?ref=CODE on any landing URL (referral program) — read once at boot.
try {
  const ref = new URLSearchParams(window.location.search).get("ref");
  if (ref) localStorage.setItem("mf_ref", ref.toUpperCase().slice(0, 12));
} catch { /* storage unavailable */ }

export function audioUrl(path) {
  return `${API}/audio/${path}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
